/* istanbul ignore file */
import styled from 'styled-components';
import { AppBar as ECAppBar } from '@econsult/econsult-ui/dist/components/AppBar/styles';
import { AppBarButton } from '@econsult/econsult-ui/dist/components/AppBar/AppBarButton';

export const StyledAppBar = styled(ECAppBar)`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 0.25rem 2.5rem;
  background: #D2D1DB;
`;

export const StyledAppBarButton = styled(AppBarButton)`
  &[data-automation^="AppBarButton"] {
    padding: 4px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    box-sizing: border-box;
  }

  &[data-automation^="AppBarButton"] span[data-automation^="AppBarButtonIcon"] {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  &[data-automation="AppBarButton-Scribe"] span[data-automation^="AppBarButtonIcon"] {
    width: 40px;
    height: 40px;
    padding: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &[data-automation="AppBarButton-Scribe"] span[data-automation^="AppBarButtonIcon"] svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;
